import {
  Component,
  h,
  Host, State, Event, EventEmitter, Listen, Prop
} from '@stencil/core';

@Component({
  tag: 'envc-search',
  styleUrl: 'envc-search.scss',
  shadow: true
})

export class EnvcSearch {
  @State() toggleSearchDrawerState: boolean
  @Event() openSearchDrawerEvent: EventEmitter<{ state: boolean | null }>

  @Prop() isDesignMode: string;

  private handleAppDrawerEvent() {
    this.toggleSearchDrawerState = !this.toggleSearchDrawerState
    this.openSearchDrawerEvent.emit({ state: this.toggleSearchDrawerState })
  }

  @Listen('openSearchDrawerEvent', { target: 'window' })
  openSearchDrawerEventEventHandler(event: CustomEvent<{state: boolean | null}>) {
    this.toggleSearchDrawerState = event?.detail?.state
  }

  render() {
    return (
      <Host>
        <div
          aria-expanded={this.toggleSearchDrawerState || this.isDesignMode === 'is-design-mode' ? 'true' : 'false'}
          class={{ 'search-drawer' : true, 'sitefinity' : this.isDesignMode === 'is-design-mode' }}
        >
          <div class="search-drawer__wrapper">
            <div class="search-drawer__content">
              <slot />
            </div>

            <button
              type="button"
              class="search-drawer__close-button"
              onClick={() => this.handleAppDrawerEvent()}
            >
              Suche schließen
            </button>
          </div>
        </div>
      </Host>
    );
  }
}
